import { render } from "./App.vue?vue&type=template&id=23c5b883&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=23c5b883&lang=less"
import "./App.vue?vue&type=style&index=1&id=23c5b883&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c5b883"]])

export default __exports__